import { API_VERSION, EndPoint, CALLFLOW_API_VERSION } from './consts.mjs';

// © Sitecore Corporation A/S. All rights reserved. Sitecore® is a registered trademark of Sitecore Corporation A/S.
/**
 * Creates the URL for retrieving the browser ID from Sitecore CDP
 * @param targetURL - From global settings
 * @param clientKey - From global settings
 * @returns The URL string for retrieving the browser ID
 */
function generateCreateBrowserIdUrl(targetURL, clientKey) {
    // eslint-disable-next-line max-len
    return `${targetURL}/${API_VERSION}/${EndPoint.Browser}/create.json?client_key=${clientKey}&message={}`;
}
/**
 * Creates the URL for sending callFlows to Sitecore CDP with the Version
 * @param targetURL - From global settings
 * @returns The URL string for sending events
 */
function generateCallFlowUrl(targetURL) {
    return `${targetURL}/${CALLFLOW_API_VERSION}/${EndPoint.CallFlows}`;
}

export { generateCallFlowUrl, generateCreateBrowserIdUrl };
